import { TaskCategoryTaskType } from '@urbanx/agx.activities.client';
import AgreementDetails from './AgreementDetails/AgreementDetails';
import { AgreementCompliancePageProps } from './AgreementCompliancePageProps';
import AgreementComplianceTypePage from './AgreementComplianceType/AgreementComplianceTypePage';
import AgreementCommissionPage from './AgreementCommission/AgreementCommissionPage';

const AgreementCompliancePages = (props: AgreementCompliancePageProps) => {
  if (props.task.category?.taskType !== TaskCategoryTaskType.AgreementCompliance) {
    throw new Error('Agreement Compliance pages require the canonical compliance task');
  }

  if (props.taskNumber === 1) return <AgreementDetails {...props} />;
  if (props.taskNumber === 2) return <AgreementComplianceTypePage {...props} />;
  if (props.taskNumber === 3) return <AgreementCommissionPage {...props} />;

  throw new Error(`Agreement Compliance page ${props.taskNumber} is not supported`);
};

export default AgreementCompliancePages;
